export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

export const numberRegex = /^\d*$/;

export const textRegex = /^[a-zA-ZÀ-ÿ ]*$/;

export const alphanumericRegex = /^[0-9a-zA-ZÀ-ÿ ]*$/;

export const passwordRegex =
  /^[a-zA-Z0-9^$*.[\]{}()?"!@#%&/,><':;|_~`\\=+-]*$/;
